var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscriptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46576 0.910156H2.75796C2.23796 0.910156 1.81641 1.34111 1.81641 1.87272V8.12941C1.81641 8.66102 2.23796 9.09197 2.75796 9.09197H7.46576C7.98576 9.09197 8.40731 8.66102 8.40731 8.12941V1.87272C8.40731 1.34111 7.98576 0.910156 7.46576 0.910156Z",
    stroke: "#FCFAFA",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69922 3.31641H6.52389M3.69922 5.24154H6.52389M3.69922 7.16667H5.58234",
    stroke: "#FCFAFA",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscriptionIcon);
export default __webpack_public_path__ + "static/media/discription_icon.e5a5f2c5a1b53d625d69fda085b05266.svg";
export { ForwardRef as ReactComponent };